import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { serviceConstants } from 'src/app/constants/service.constants';
@Injectable({
  providedIn: 'root'
})
export class AuditlogServiceService {
  
  jsonOptions: { responseType: 'json' | undefined, withCredentials: boolean | undefined } = { responseType: "json", withCredentials: true };

  constructor(private readonly http: HttpClient) { }

  searchRecords(model: SuperAdminAuditLogSearch): Observable<AuditResponses> {
    return this.http.post<AuditResponses>(serviceConstants.apiURL + "api/SuperAdminAuditLog/GetAuditLogRecordList/", model, this.jsonOptions);
  }

  GetAuditLogDetailsList(VersionId: AuditLogsearch): Observable<AuditLogsearch> {
    return this.http.post<AuditLogsearch>(serviceConstants.apiURL + 'api/SuperAdminAuditLog/GetAuditLogDetailsList', VersionId, this.jsonOptions);
  }

  GetAuditLogRevisionList(Name: string, CategoryType: string): Observable<any> {
    return this.http.get<any>(serviceConstants.apiURL + 'api/SuperAdminAuditLog/GetAuditLogRevisionList?RelatedPkId=' + Name + '&CatergoryType=' + CategoryType, this.jsonOptions);
  } 

  getHeaders(): any {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true
    };
    return httpOptions;
  }
}

export interface SuperAdminAuditLogSearch {
  Category: string,
  Name: string,
  StartDate: string,
  EndDate: string 
}

export interface AuditLogsearch {
  versionIDs: any[],
  categories: string,
}

export interface SuperAdminAuditDetails {
  VersionID: string,
  RevisionNum: string,
  FieldName: string,
  OldValue: string,
  NewValue: string,
  CreatedDate: string,
  CreatedBy: string,
}
export interface AuditResponses {
  SuccessMessage?: string;
  errMessage?: string;
  Status?: string;
  errorList?: string[];
  StatusCode?: string;
  Data?: any;
}